<ng-container *ngIf="isBrowser; else server">
  <ng-container *ngIf="fill; else normal">
    <div *ngIf="src"
         [style.width.px]="targetWidth"
         [style.height.px]="targetHeight">
      <img class="object-fit"
           [class.cursor-pointer]="clickable"
           [class.disabled-select]="!selectable"
           [fill]="true"
           [style.border-radius.px]="borderRadius"
           [ngSrc]="src"
           [title]="tooltip"
           [alt]="alt"
           [loading]="loading()"
           [loaderParams]="{originalQuality: originalQuality}"
           (load)="onImageLoaded()"/>
    </div>
  </ng-container>
  <ng-template #normal>
    @if (isMobile) {
      <div class="relative" *ngIf="size && src"
           style="display: inline-block"
           [style.width.px]="size[0]"
           [style.height.px]="size[1]">
        <img class="object-contain"
             style="display: block"
             [class.not-cut]="platform.SAFARI"
             [class.cursor-pointer]="clickable"
             [class.disabled-select]="!selectable"
             [style.border-radius.px]="borderRadius"
             [style.vertical-align]="middle ? 'middle' : 'unset'"
             [fill]="true"
             [ngSrc]="src"
             [loading]="loading()"
             [title]="tooltip"
             [alt]="alt"
             [loaderParams]="{originalQuality: originalQuality}"
             (load)="onImageLoaded()"/>
      </div>
    } @else {
      <img *ngIf="size && src"
           [class.not-cut]="platform.SAFARI"
           [class.cursor-pointer]="clickable"
           [class.disabled-select]="!selectable"
           [style.border-radius.px]="borderRadius"
           [style.vertical-align]="middle ? 'middle' : 'unset'"
           [width]="size[0]"
           [height]="size[1]"
           [ngSrc]="src"
           [loading]="loading()"
           [title]="tooltip"
           [alt]="alt"
           [loaderParams]="{originalQuality: originalQuality}"
           (load)="onImageLoaded()"/>
    }
  </ng-template>
</ng-container>
<ng-template #server>
  <ng-container *ngIf="fill; else normal">
    <img class="object-fit" *ngIf="src"
         [style.width]="imgWidthCss()"
         [style.height]="imgHeightCss()"
         [style.border-radius.px]="borderRadius"
         [src]="src | imageUrl: (originalQuality ? '' : ssrSuffix)"
         [title]="tooltip"
         [alt]="alt"/>
  </ng-container>
  <ng-template #normal>
    <img *ngIf="size && src"
         [style.border-radius.px]="borderRadius"
         [style.vertical-align]="middle ? 'middle' : 'unset'"
         [src]="src | imageUrl: (originalQuality ? '' : ssrSuffix)"
         [title]="tooltip"
         [alt]="alt"
         [style.width]="imgWidthCss()"
         [style.height]="imgHeightCss()"/>
  </ng-template>
</ng-template>
